'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Drawer = _interopDefault(require('@material-ui/core/Drawer'));
var styledComponents = require('./styled-components.js');

var DrawerModal = function (props) {
    var children = props.children, open = props.open, _a = props.anchor, anchor = _a === void 0 ? 'right' : _a, closeDrawer = props.closeDrawer, headerComponent = props.headerComponent, footerComponent = props.footerComponent, minWidth = props.minWidth, _b = props.disableEnforceFocus, disableEnforceFocus = _b === void 0 ? false : _b, _c = props.className, className = _c === void 0 ? '' : _c, maxWidth = props.maxWidth;
    return (React__default.createElement(Drawer, { variant: 'temporary', anchor: anchor, open: open, onClose: closeDrawer, transitionDuration: 500, "data-testid": 'drawer menu', ModalProps: { disableEnforceFocus: disableEnforceFocus }, className: className },
        React__default.createElement(styledComponents.DrawerContainer, { minWidth: minWidth, maxWidth: maxWidth },
            React__default.createElement(styledComponents.HeaderContainer, null, headerComponent),
            React__default.createElement(styledComponents.ChildrenContainter, null, children),
            footerComponent && React__default.createElement(styledComponents.FooterContainer, null, footerComponent))));
};

module.exports = DrawerModal;
